import { render, staticRenderFns } from "./GroupsAndUsersList.vue?vue&type=template&id=4f5d5c28&scoped=true&"
import script from "./GroupsAndUsersList.vue?vue&type=script&lang=js&"
export * from "./GroupsAndUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d5c28",
  null
  
)

export default component.exports